import { IntlShape } from 'react-intl'
import { formatCount, NO_VALUE } from '../UrgencySummary/urgencySummaryFormat'

/**
 * Formato de los números de la pantalla, en un solo lugar. La cantidad va siempre con separador de miles (`formatCount`,
 * el mismo de Atenciones de urgencia y Recién nacidos) y los porcentajes y las estadías, siempre con un decimal ("27,0 %"
 * y no "27 %"): así dos filas seguidas no se ven con decimales desparejos.
 */

export { formatCount, NO_VALUE }

const ONE_DECIMAL = { useGrouping: 'always', minimumFractionDigits: 1, maximumFractionDigits: 1 } as const

/** `percent` ya está en % (27 = 27 %): "27,0 %", o "—" si no hay dato. */
export function formatPercent(intl: IntlShape, percent: number | null | undefined): string {
  if (percent === null || percent === undefined) return NO_VALUE
  return `${intl.formatNumber(percent, ONE_DECIMAL)} %`
}

/** Qué parte de `total` es `part`, en % (sin redondear); null si no hay total (0 o sin dato). */
export function shareOf(part: number | null | undefined, total: number | null | undefined): number | null {
  if (part === null || part === undefined || total === null || total === undefined || total <= 0) return null
  return (part / total) * 100
}

/** Número con un decimal ("3,1"), o "—" si no hay dato. */
export function formatDecimal(intl: IntlShape, value: number | null | undefined): string {
  if (value === null || value === undefined) return NO_VALUE
  return intl.formatNumber(value, ONE_DECIMAL)
}

/** Cantidad, o "—" si no hay dato (celda de tabla). */
export function formatCountOrDash(intl: IntlShape, value: number | null | undefined): string {
  return value === null || value === undefined ? NO_VALUE : formatCount(intl, value)
}
